import CategoriesSVG from "@design-system/ui-icons/vanilla/Categories"
import { createIcon } from "../createIcon"

export const CategoriesIcon = createIcon(CategoriesSVG)
